import React, { useMemo } from 'react';

import { Box, BoxProps } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

import GoalImageLoader from './GoalImageLoader';

export const images = Object.freeze({
  apple: () => import('./AppleLight'),
  baby: () => import('./BabyLight'),
  bandaid: () => import('./BandaidLight'),
  business: () => import('./BusinessLight'),
  cap: () => import('./CapLight'),
  car: () => import('./CarLight'),
  card: () => import('./CardLight'),
  charity: () => import('./CharityLight'),
  coin: () => import('./CoinLight'),
  dollar: () => import('./DollarLight'),
  home: () => import('./HomeLight'),
  lifering: () => import('./LiferingLight'),
  parasol: () => import('./ParasolLight'),
  plane: () => import('./PlaneLight'),
  plant: () => import('./PlantLight'),
  present: () => import('./PresentLight'),
  tree: () => import('./TreeLight'),
  watering_can: () => import('./WateringCanLight'),
  wedding: () => import('./WeddingLight'),
});

export interface GoalImageProps extends BoxProps {
  name: keyof typeof images | 'custom';
  size?: string;
  rounded: boolean;
  className?: string;
  mode?: string;
}

export interface ImageProps {
  rounded: boolean;
}

export const Image = styled.img`
  max-width: 100%;
`;

export const RoundedEdgeImage = styled(Image)`
  border-radius: 0.8rem;
`;

const GoalImageComponent: React.FC<React.PropsWithChildren<GoalImageProps>> = ({
  className,
  size = '184px',
  name,
  rounded = false,
  ...boxProps
}) => {
  const ImageComponent = useMemo(() => {
    return React.lazy(name === 'custom' ? images.present : images[name]); // TODO: replace with user-selected image
  }, [name]);

  return (
    <React.Suspense fallback={<GoalImageLoader size={size} rounded={rounded} />}>
      <Box {...boxProps} className={className} size={size} minWidth={size} maxWidth={size}>
        <ImageComponent rounded={rounded} />
      </Box>
    </React.Suspense>
  );
};

export const GoalImage: React.FC<React.PropsWithChildren<GoalImageProps>> = ({
  className,
  size = '184px',
  name,
  rounded = false,
  ...boxProps
}) => {
  return (
    <GoalImageComponent
      className={className}
      size={size}
      name={name as keyof typeof images}
      rounded={rounded}
      {...boxProps}
    />
  );
};
